import { Injectable } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PicService {


  constructor(private httpService: HttpService) { }
  
  getPicHeader(params: any): Observable<any> {
    return this.httpService.get('pic-header', params);
  }
  updatePic(data: any): Observable<any> {
    return this.httpService.put('pic-detail', data);
  }
  detailPic(data: any): Observable<any> {
    return this.httpService.get('pic-detail',data);
  }
  deleteDetail(detailId: any): Observable<any> {
    return this.httpService.delete(`pic-detail/${detailId}`);
  }

}
